import { Box, Chip, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { EXPERIENCES } from "../constants/experience";
import { KeyboardArrowLeft } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
const Experience = () => {
  const navigate = useNavigate()
  const theme = useTheme();
  const chipColor = theme.palette.secondary.main;
  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        my={2}
      >
        <IconButton onClick={() => navigate('/')}>
          <KeyboardArrowLeft sx={{ color: 'text.secondary' }} />
        </IconButton>
        <Typography variant='h4' pl={1}>
          Experience & Education
        </Typography>
      </Stack>

      {
        EXPERIENCES.map((experience) => (
          <>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <Box>
                <Typography variant="h5">
                  {experience.role}
                </Typography>
                <Typography variant="body2" color="text.secondary" component="p" sx={{ mb: 1 }}>
                  {experience.company}
                </Typography>
              </Box>
              <Chip
                label={experience.duration}
                sx={{
                  background: chipColor,
                   color: 'text.inverted'
                }} />
            </Box>

            <Box component="ul" sx={{
              pl: 2,
              mt: 0,
              mb: 3,
              listStyleType: 'disc',
              '& li': {
                mt: 0.5,
                color: 'text.primary',
                lineHeight: 1.5
              }
            }}>
              {experience.description.map((desc, index) => (
                <li key={index}>
                  <Typography>{desc}</Typography>
                </li>
              ))}
            </Box>
          </>
        ))
      }

    </>
  )
}

export default Experience;